<nav class="landing-nav">
    <div class="flex">
        <a routerLink="/" class="logo-nav">
            <img src="./assets/logo_nav.svg" alt="">
        </a>
        <button class="btn-nav-responsive" (click)="isMenuVisible=!isMenuVisible" >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 6H20M4 12H20M4 18H20" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                
        </button>
    </div>
    <ul class="nav-desktop">
        <li><a routerLink="/" fragment="caracteristicas"  [class.active]='activeRouteService.activeRoute()==="home-chara"'>Características</a></li>
        <li><a routerLink="/" fragment="como" [class.active]='activeRouteService.activeRoute()==="home-how"'>Cómo Funciona</a></li>
        <li><a routerLink="/"  fragment="preguntas"
            [class.active]='activeRouteService.activeRoute()==="home-quest"'>Preguntas</a></li>
        <!-- <li><a routerLink="/" fragment="planes" [class.active]='activeRouteService.activeRoute()==="home-plan"'>Planes</a></li> -->
        <li><a routerLink="/" fragment="ubicaciones" [class.active]='activeRouteService.activeRoute()==="home-loc"'>Ubicaciones</a></li>
        <li><a routerLink="/" fragment="contacto" [class.active]='activeRouteService.activeRoute()==="home-contact"'>Contacto</a></li>
    </ul>
   
    <div class="links-cont">
        <a routerLink="/auth/login">Iniciar sesión</a>
        <a routerLink="/auth/register" class="button-primary register-button">Suscribite ya</a>
    </div>
</nav>
<div class="menu-responsive-cont">
    <div class="overlay-menu" [class.active]="isMenuVisible" (click)="isMenuVisible=false"></div>
    <ul class="menu-responsive " [class.active]="isMenuVisible">
            <li><a routerLink="/" fragment="caracteristicas"  [class.active]='activeRouteService.activeRoute()==="home-chara"'>Características</a></li>
        <li><a routerLink="/" fragment="como" [class.active]='activeRouteService.activeRoute()==="home-how"'>Cómo Funciona</a></li>
        <li><a routerLink="/"  fragment="preguntas"
            [class.active]='activeRouteService.activeRoute()==="home-quest"'>Preguntas</a></li>
        <!-- <li><a routerLink="/" fragment="planes" [class.active]='activeRouteService.activeRoute()==="home-plan"'>Planes</a></li> -->
        <li><a routerLink="/" fragment="ubicaciones" [class.active]='activeRouteService.activeRoute()==="home-loc"'>Ubicaciones</a></li>
        <li><a routerLink="/" fragment="contacto" [class.active]='activeRouteService.activeRoute()==="home-contact"'>Contacto</a></li>
    </ul>
</div>